/**
 * OGP API
 *
 * Thin request wrapper around the server-side OGP fetch endpoints.
 */

import { ApiBase, HttpMethod } from "../../core/api-base";
import { z } from "zod";
import { FetchOgpBody, FetchOgpImageBody } from "../../api/generated/ogp.zod";
import { UrlExtractor } from "../url/url-extractor";

type FetchOgpPayload = z.infer<typeof FetchOgpBody>;
type FetchOgpImagePayload = z.infer<typeof FetchOgpImageBody>;

class OgpApi extends ApiBase {
    public async fetchOgp(url: string): Promise<Response> {
        const cleanedUrl = UrlExtractor.cleanUrl(String(url || ""));
        const payload: FetchOgpPayload = { url: cleanedUrl };
        return super.apiRequest("/api/v1/ogp/fetch", HttpMethod.Post, payload);
    }

    public async fetchOgpImage(url: string): Promise<Response> {
        const cleanedUrl = UrlExtractor.cleanUrl(String(url || ""));
        const payload: FetchOgpImagePayload = { url: cleanedUrl };
        return super.apiRequest("/api/v1/ogp/fetch-image", HttpMethod.Post, payload);
    }
}

export { OgpApi };
